import { EntityOption } from '@context/shared/types/common';
import { Chemical } from '../types';

export class ChemicalOption extends EntityOption<Chemical> {
	protected override toString() {
		return this.data.name;
	}
}
